import localeRo from '@angular/common/locales/ro';
import localeRoExtra from '@angular/common/locales/extra/ro';

import { LanguageEnum, Language } from '../core/interfaces/language-types';

export default class RomanianLanguage extends Language {
  protected locale = localeRo;
  protected localeExtra = localeRoExtra;
  protected details = {
    image: 'images/flags/ro.png',
    title: 'Romanian',
    enum: LanguageEnum.Romanian,
    aira: 'Romanian Selected',
    select: 'Choose Romanian Language',
    abre: 'ro'
  };
}
